import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../../lib/api";
import { ProductCard } from "../site/ProductCard";
import { Eyebrow, Reveal } from "../site/Reveal";

export const Featured = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    http
      .get("/products", { params: { featured: true, limit: 8 } })
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, []);

  if (items && items.length === 0) return null;

  return (
    <section data-testid="featured-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-12">
      <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <Eyebrow>On the shelf now</Eyebrow>
          <h2 className="mt-4 font-display text-5xl font-black uppercase leading-[0.9] tracking-tight sm:text-7xl">Featured parts</h2>
        </div>
        <Link to="/shop" data-testid="featured-view-all" className="rounded-full border border-white/20 px-6 py-3 text-sm font-semibold transition-colors hover:border-white">
          Shop all
        </Link>
      </Reveal>
      <div className="grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {(items ?? []).map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
      </div>
    </section>
  );
};
